import { useFormik } from "formik";
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { generateValidationSchema } from "./Validations";
import { useAddpatientMutation, useLazyGetpatientQuery } from "../State/Api/AddpatientApiSlice";

import { useLazyGetalldoctorsQuery } from "../State/Api/AdddocApiSlice";


function AddPatient() {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA");
  };
  const navigate = useNavigate();
  const params = useLocation();

  const patientId = params?.state?.id;
  
  const [fetchPatient, { data: patientData, isFetching, failed }] =
    useLazyGetpatientQuery();
  const [addpatient, { isSuccess, isError, isLoading, error }] =
    useAddpatientMutation();
  const [fetchallDoctor, { data: alldoctorsData, isAdding, fail }] =
    useLazyGetalldoctorsQuery();
    const clinicUserId = localStorage.getItem("userClinicID");

  useEffect(() => {
    if (patientId) {
      fetchPatient(patientId);
    }
  }, [patientId]);
  useEffect(() => {
    fetchallDoctor(clinicUserId); // Trigger fetch on mount
  }, [clinicUserId]);
 
  
  const formFields = [
    "email",
    "fullname",
    "gender",
    "dateofbirth",
    "phonenumber",
    "address",
    "emergencycontactnumber",
    "patientid",
    "age",
    "martialstatus",
    "emergencycontactname",
    "relationtopatient",
    "addmissiontype",
    "primarydiagnosis",
    "symptons",
    "allergiesifany",
    "existingmedicalconditions",
    "assigneddoctor",
    "treatmentplansummary",
    "medicationsprescribed",
    "labdiagnostictestsordered",
    "roomwardnumber",
    "dateofadmissionvisit",
    "expecteddischarge",
    "followupappointmentdate",
    "insuranceprovider",
    "insurancepolicynumber",
    "billingstatus",
    "paymentmethod",
  ];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      userclinicid: clinicUserId,
      email: "",
      fullname: "",
      gender: "",
      dateofbirth: "",
      phonenumber: "",
      address: "",
      emergencycontactnumber: "",
      patientid: "",
      age: "",
      martialstatus: "",
      emergencycontactname: "",
      relationtopatient: "",
      addmissiontype: "",
      primarydiagnosis: "",
      symptons: "",
      allergiesifany: "",
      existingmedicalconditions: "",
      assigneddoctor: "",
      treatmentplansummary: "",
      medicationsprescribed: "",
      labdiagnostictestsordered: "",
      roomwardnumber: "",
      dateofadmissionvisit: "",
      expecteddischarge: "",
      followupappointmentdate: "",
      insuranceprovider: "",
      insurancepolicynumber: "",
      billingstatus: "",
      paymentmethod: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => handleSubmit(values, { resetForm }),
  });
  // if patient data
  useEffect(() => {
    if (patientData) {
      formik.setValues({
        // patientid: patientData?.basicInfo?.patientid || "",
        email: patientData?.basicInfo?.emailaddress || "",
        fullname: patientData?.basicInfo?.fullname || "",
        age: patientData?.basicInfo?.age || "",
        gender: patientData?.basicInfo?.gender || "",
        dateofbirth: formatDate(patientData?.basicInfo?.dateofbirth) || "",
        martialstatus: patientData?.basicInfo?.martialstatus || "",
        phonenumber: patientData?.basicInfo?.contactnumber || "",
        address: patientData?.basicInfo?.address || "",
        emergencycontactname:
          patientData?.basicInfo?.emergencycontactname || "",
        emergencycontactnumber:
          patientData?.basicInfo?.emergencycontactnumber || "",
        relationtopatient: patientData?.basicInfo?.relationtopatient || "",
        addmissiontype: patientData?.medicalinfo?.addmissiontype || "",
        primarydiagnosis: patientData?.medicalinfo?.primarydiagnosis || "",
        symptons: patientData?.medicalinfo?.symptons || "",
        allergiesifany: patientData?.medicalinfo?.allergies_ifany || "",
        existingmedicalconditions:
          patientData?.medicalinfo?.existingmedicalconditions || "",
        assigneddoctor: patientData?.medicalinfo?.assigneddoctor || "",
        treatmentplansummary:
          patientData?.medicalinfo?.treatmentplansummary || "",
        medicationsprescribed:
          patientData?.medicalinfo?.medicationsprescribed || "",
        labdiagnostictestsordered:
          patientData?.medicalinfo?.labdiagnostictestsordered || "",
        roomwardnumber:
          patientData?.medicalinfo?.roomwardnumber_ifInPatient || "",
        dateofadmissionvisit:
          formatDate(patientData?.admissionvisitinfo?.dateofadmissionvisit) ||
          "",
        expecteddischarge:
          formatDate(patientData?.admissionvisitinfo?.expecteddischargedate) ||
          "",
        followupappointmentdate:
          formatDate(
            patientData?.admissionvisitinfo?.followupappointmentdate
          ) || "",
        insuranceprovider: patientData?.insuranceinfo?.insuranceprovider || "",
        insurancepolicynumber:
          patientData?.insuranceinfo?.insurancepolicynumber || "",
        billingstatus: patientData?.insuranceinfo?.billingstatus || "",
        paymentmethod: patientData?.insuranceinfo?.paymentmethod || "",
      });
    }
  }, [patientData]);

  const handleSubmit = async (values, resetForm) => {
    const value = {
      admissionvisitinfo: {
        dateofadmissionvisit: values?.dateofadmissionvisit,
        expecteddischargedate: values?.expecteddischarge,
        followupappointmentdate: values?.followupappointmentdate,
        userclinicid: clinicUserId,
      },
      basicInfo: {
        // patientid: values?.patientid,
        fullname: values?.fullname,
        userclinicid: clinicUserId,
        age: values?.age,
        dateofbirth: values?.dateofbirth,
        gender: values?.gender,
        martialstatus: values?.martialstatus,
        contactnumber: values?.phonenumber,
        emailaddress: values?.email,
        address: values?.address,
        emergencycontactname: values?.emergencycontactname,
        emergencycontactnumber: values?.emergencycontactnumber,
        relationtopatient: values?.relationtopatient,
      },
      insuranceinfo: {
        insuranceprovider: values?.insuranceprovider,
        userclinicid: clinicUserId,
        insurancepolicynumber: values?.insurancepolicynumber,
        billingstatus: values?.billingstatus,
        paymentmethod: values?.paymentmethod,
      },
      medicalinfo: {
        addmissiontype: values?.addmissiontype,
        userclinicid: clinicUserId,
        primarydiagnosis: values?.primarydiagnosis,
        symptons: values?.symptons,
        allergies_ifany: values?.allergiesifany,
        existingmedicalconditions: values?.existingmedicalconditions,
        assigneddoctor: values?.assigneddoctor,
        treatmentplansummary: values?.treatmentplansummary,
        medicationsprescribed: values?.medicationsprescribed,
        labdiagnostictestsordered: values?.labdiagnostictestsordered,
        roomwardnumber_ifInPatient: values?.roomwardnumber,
      },
    };

    try {
      if (value) {
      
        const result = await addpatient(value).unwrap();
        const parsedResult =
          typeof result === "string" ? JSON.parse(result) : result;
        
        if (parsedResult?.result_Code === 100) {
       
          navigate("/ClinicPatients");
          resetForm();
        } else if (parsedResult?.result_Code === 200) {
          navigate("/ClinicPatients");
        }
      }
    } catch (error) {
    
    }
  };

  return (
    <>
      <main className="ms-2 p-2">
        <div style={{ width: "100%", height: "100%" }}>
          <div className="row bg-white p-2 rounded-2">
            <div className="col-12 mb-2">
              <h4 className="m-0 mt-2 ml-2" style={{ color: "#000" }}>
                {patientId ? "Update Patient Details" : "Add Patient Details"}
              </h4>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Basic Information
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Patient ID
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="patientid"
                                name="patientid"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.patientid}
                                disabled
                              />
                              {formik.touched.patientid &&
                              formik.errors.patientid ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.patientid}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Full Name
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="fullname"
                                name="fullname"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.fullname}
                              />
                              {formik.touched.fullname &&
                              formik.errors.fullname ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.fullname}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">Age</Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="age"
                                name="age"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.age}
                              />
                              {formik.touched.age && formik.errors.age ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.age}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Date of Birth
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="dateofbirth"
                                name="dateofbirth"
                                type="date"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.dateofbirth}
                              />
                              {formik.touched.dateofbirth &&
                              formik.errors.dateofbirth ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.dateofbirth}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Gender
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                id="gender"
                                name="gender"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.gender}
                              >
                                <option value="" disabled hidden>
                                  Select Gender
                                </option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </select>
                              {formik.touched.gender && formik.errors.gender ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.gender}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Martial status{" "}
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                id="martialstatus"
                                name="martialstatus"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.martialstatus}
                              >
                                <option value="" disabled hidden>
                                  Select Status
                                </option>
                                <option value="single">Single</option>
                                <option value="married">Married</option>
                              </select>
                              {formik.touched.martialstatus &&
                              formik.errors.martialstatus ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.martialstatus}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Contact Number
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="phonenumber"
                                id="phonenumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.phonenumber}
                              />
                              {formik.touched.phonenumber &&
                              formik.errors.phonenumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.phonenumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Email Address
                              <span style={{ color: "grey" }}>*</span>
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="email"
                                name="email"
                                id="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.email}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Address
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="address"
                                id="address"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.address}
                              />
                              {formik.touched.address &&
                              formik.errors.address ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.address}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Emergency Contact Name
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="emergencycontactname"
                                id="emergencycontactname"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.emergencycontactname}
                              />
                              {formik.touched.emergencycontactname &&
                              formik.errors.emergencycontactname ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.emergencycontactname}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Emergency Contact Number
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="emergencycontactnumber"
                                id="emergencycontactnumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.emergencycontactnumber}
                              />
                              {formik.touched.emergencycontactnumber &&
                              formik.errors.emergencycontactnumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.emergencycontactnumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Relation to Patient
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="relationtopatient"
                                id="relationtopatient"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.relationtopatient}
                              />
                              {formik.touched.relationtopatient &&
                              formik.errors.relationtopatient ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.relationtopatient}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Medical Information
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Addmission Type
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                type="text"
                                name="addmissiontype"
                                id="addmissiontype"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.addmissiontype}
                              >
                                <option value="" disabled hidden>
                                  Select Type
                                </option>
                                <option value="in-patient">In-Patient</option>
                                <option value="out-patient">Out-Patient</option>
                              </select>
                              {formik.touched.addmissiontype &&
                              formik.errors.addmissiontype ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.addmissiontype}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Primary Diagnosis
                            </Form.Label>
                            <div>
                              <textarea
                                class="div-LableInput"
                                id="primarydiagnosis"
                                name="primarydiagnosis"
                                rows="3"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.primarydiagnosis}
                              ></textarea>
                              {formik.touched.primarydiagnosis &&
                              formik.errors.primarydiagnosis ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.primarydiagnosis}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Symptons
                            </Form.Label>
                            <div>
                              <textarea
                                class="div-LableInput"
                                id="symptons"
                                name="symptons"
                                rows="3"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.symptons}
                              ></textarea>
                              {formik.touched.symptons &&
                              formik.errors.symptons ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.symptons}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Allergies (if any)
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="allergiesifany"
                                id="allergiesifany"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.allergiesifany}
                              />
                              {formik.touched.allergiesifany &&
                              formik.errors.allergiesifany ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.allergiesifany}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                            <Form.Label className="mb-0 ms-4">
                              Existing Medical Conditions
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                name="existingmedicalconditions"
                                id="existingmedicalconditions"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.existingmedicalconditions}
                              >
                                <option value="" disabled hidden>
                                  Select Medical Conditions
                                </option>
                                <option value="none">None</option>
                                <option value="diabetes">Diabetes</option>
                                <option value="hyper tension">
                                  Hyper Tension
                                </option>
                              </select>
                              {formik.touched.existingmedicalconditions &&
                              formik.errors.existingmedicalconditions ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.existingmedicalconditions}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Assigned Doctor{" "}
                            </Form.Label>
                            <div>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                name="assigneddoctor"
                                id="assigneddoctor"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.assigneddoctor}
                              >
                                <option value="" disabled hidden>
                                  Select Doctors
                                </option>

                                {alldoctorsData?.map((doctor) => (
                                  <option
                                    key={doctor.id}
                                    value={`${doctor.fullName} (${doctor.specialization})`}
                                  >
                                    {doctor.fullName} ({doctor.specialization}
                                    )
                                  </option>
                                ))}
                              </select>
                              {formik.touched.assigneddoctor &&
                              formik.errors.assigneddoctor ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.assigneddoctor}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Treatment Plan Summary
                            </Form.Label>
                            <div>
                              <textarea
                                class="div-LableInput"
                                id="treatmentplansummary"
                                name="treatmentplansummary"
                                rows="3"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.treatmentplansummary}
                              ></textarea>
                              {formik.touched.treatmentplansummary &&
                              formik.errors.treatmentplansummary ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.treatmentplansummary}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Medications Prescribed
                              <span style={{ color: "grey" }}>*</span>
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="medicationsprescribed"
                                id="medicationsprescribed"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.medicationsprescribed}
                              />
                              {formik.touched.medicationsprescribed &&
                              formik.errors.medicationsprescribed ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.medicationsprescribed}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              {" "}
                              Lab/Diagnostic Tests Ordered{" "}
                              <span style={{ color: "grey" }}>*</span>
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="labdiagnostictestsordered"
                                id="labdiagnostictestsordered"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.labdiagnostictestsordered}
                              />
                              {formik.touched.labdiagnostictestsordered &&
                              formik.errors.labdiagnostictestsordered ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.labdiagnostictestsordered}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Room/Ward Number (if In-Patient)
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="roomwardnumber"
                                id="roomwardnumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.roomwardnumber}
                              />
                              {formik.touched.roomwardnumber &&
                              formik.errors.roomwardnumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.roomwardnumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-6 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                    paddingBottom: "3rem",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Admission/Visit Details
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-2 mt-3">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Date of Admission/Visit
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            id="dateofadmissionvisit"
                            name="dateofadmissionvisit"
                            type="date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.dateofadmissionvisit}
                          />
                          {formik.touched.dateofadmissionvisit &&
                          formik.errors.dateofadmissionvisit ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.dateofadmissionvisit}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Expected Discharge Date (if applicable)
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="date"
                            name="expecteddischarge"
                            id="expecteddischarge"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.expecteddischarge}
                          />
                          {formik.touched.expecteddischarge &&
                          formik.errors.expecteddischarge ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.expecteddischarge}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                        <Form.Label className="mb-0 ms-4">
                          Follow-Up Appointment Date
                          <span style={{ color: "grey" }}>*</span>
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            id="followupappointmentdate"
                            name="followupappointmentdate"
                            type="date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.followupappointmentdate}
                          />
                          {formik.touched.followupappointmentdate &&
                          formik.errors.followupappointmentdate ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.followupappointmentdate}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-12">
                    <div className="d-flex p-2 align-items-center justify-content-between">
                      <Form.Label className="mb-0 ms-4">
                       Compliance Certifications <span style={{color:"grey"}}>*</span>
                      </Form.Label>
                      <input
                        className="div-LableInput"
                        type="text"
                        name=""
                        id=""
                      />
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Insurance/Billing Information
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-2 mt-3">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Insurance Provider
                          <span style={{ color: "grey" }}>*</span>
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="insuranceprovider"
                            id="insuranceprovider"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.insuranceprovider}
                          />
                          {formik.touched.insuranceprovider &&
                          formik.errors.insuranceprovider ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.insuranceprovider}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Insurance Policy Number
                          <span style={{ color: "grey" }}>*</span>
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="insurancepolicynumber"
                            id="insurancepolicynumber"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.insurancepolicynumber}
                          />
                          {formik.touched.insurancepolicynumber &&
                          formik.errors.insurancepolicynumber ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.insurancepolicynumber}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Billing Status
                        </Form.Label>
                        <div>
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            name="billingstatus"
                            id="billingstatus"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.billingstatus}
                          >
                            <option value="" disabled hidden>
                              Select Billing Status
                            </option>
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                            <option value="partially paid">
                              Partially Paid
                            </option>
                          </select>
                          {formik.touched.billingstatus &&
                          formik.errors.billingstatus ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.billingstatus}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                        <Form.Label className="mb-0 ms-4">
                          Payment Method
                        </Form.Label>
                        <div>
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            name="paymentmethod"
                            id="paymentmethod"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.paymentmethod}
                          >
                            <option value="" disabled hidden>
                              Select Payment
                            </option>
                            <option value="cash">Cash</option>
                            <option value="card">Card</option>
                            <option value="insurance">Insurance</option>
                          </select>
                          {formik.touched.paymentmethod &&
                          formik.errors.paymentmethod ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.paymentmethod}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
              <p
                className="mb-0"
                style={{ fontSize: "0.8rem", color: "#6E7680" }}
              >
                Note
                <br />* mark indicates that the field is optional.
              </p>

              <div className="d-flex gap-3">
                <button className="div-ButtonGrey" type="button">
                  Cancel
                </button>

                <button
                  className="div-ButtonGreen"
                  type="button"
                  onClick={formik.handleSubmit}
                >
                  {patientId ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AddPatient;
